const COOKIE_CONSENT_STORAGE_KEY = "_cookie_consent";

export const isCookiebotEnabled = () => {
	if (typeof window === "undefined") return false;
	return Boolean(window.COOKIEBOT_ID);
};

const getCookiebot = () => {
	if (typeof window === "undefined") return null;
	return window.Cookiebot || null;
};

export const hasStatisticsConsent = () => {
	const cb = getCookiebot();
	return Boolean(cb?.consent?.statistics);
};

export const hasMarketingConsent = () => {
	const cb = getCookiebot();
	return Boolean(cb?.consent?.marketing);
};

export const hasPreferencesConsent = () => {
	const cb = getCookiebot();
	return Boolean(cb?.consent?.preferences);
};

const hasCookiebotResponse = () => {
	const cb = getCookiebot();
	return Boolean(cb?.hasResponse);
};

const isCookiebotAccepted = () => {
	const cb = getCookiebot();
	if (!cb) return false;
	return Boolean(cb.hasResponse && !cb.declined && cb.consent?.statistics);
};

const isDefaultAccepted = () => {
	if (typeof window === "undefined" || !window.localStorage) return false;
	return window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) === "true";
};

const isDefaultResolved = () => {
	if (typeof window === "undefined" || !window.localStorage) return false;
	const value = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
	return value === "true" || value === "false";
};

const isCookieFeatureEnabled = () => {
	if (typeof window === "undefined") return false;
	return (
		isCookiebotEnabled() ||
		window.HAS_COOKIE_POLICY_DRAWER === true ||
		window.HAS_COOKIE_POLICY_DRAWER === "true"
	);
};

export const getCookieConsent = () => {
	if (!isCookieFeatureEnabled()) return true;
	if (isCookiebotEnabled()) return isCookiebotAccepted();
	return isDefaultAccepted();
};

export const cookieConsentWasResolved = () => {
	if (!isCookieFeatureEnabled()) return true;
	if (isCookiebotEnabled()) return hasCookiebotResponse();
	return isDefaultResolved();
};

export const openCookieSettings = () => {
	if (isCookiebotEnabled()) {
		getCookiebot()?.renew?.();
		return;
	}

	if (typeof window !== "undefined" && typeof window.__toggleCookieConsent === "function") {
		window.__toggleCookieConsent(true);
	}
};

export const runCookiebotScripts = () => {
	getCookiebot()?.runScripts?.();
};

export const isCookiebotLoadFailed = () => {
	if (typeof window === "undefined") return false;
	return window.__cookiebotLoadFailed === true;
};

export const COOKIEBOT_LOAD_FAILED_EVENT = "cookiebot-load-failed";

export const onCookiebotLoadFailed = (handler) => {
	if (typeof window === "undefined") return () => {};

	if (isCookiebotLoadFailed()) {
		handler({ detail: "already-failed" });
	}

	window.addEventListener(COOKIEBOT_LOAD_FAILED_EVENT, handler);
	return () => window.removeEventListener(COOKIEBOT_LOAD_FAILED_EVENT, handler);
};

export const reloadPageForCookiebotRetry = () => {
	if (typeof window === "undefined") return;
	window.__cookiebotLoadFailed = false;
	window.location.reload();
};
